export const CHECKINGS_PROPOSITIONS: string[] = [
    'terms-and-agreement.agreement-checklist-message-1',
    'terms-and-agreement.agreement-checklist-message-2',
    'terms-and-agreement.agreement-checklist-message-3',
    'terms-and-agreement.agreement-checklist-message-4'
];
